// extracted by mini-css-extract-plugin
export default {"rgpd":"RGPD_rgpd__-ihQJ"};